import "./daily-report/daily-report.js";

import Report from "./daily-report/widgets/Report";
import Statistics from "./daily-report/widgets/Statistics";
import YearlyReport from "./yearly-report/YearlyReport";
import LegalChecksReport from "./legal-checks-report/LegalChecksReport";

Vue.component('report-widget', Report);
Vue.component('statistics-widget', Statistics);

Vue.component('yearly-report', YearlyReport);
Vue.component('legal-checks-report', LegalChecksReport);



// WEBPACK FOOTER //
// ./resources/assets/admin/js/report/index.js